import { GlassLink } from '@components/glass/GlassButton';
import { PRIMARY_CTA, SITE } from '@config/site';

import { HomeBackdrop } from './backdrop/HomeBackdrop';
import styles from './Hero.module.scss';
import { ServiceOrbit } from './orbit/ServiceOrbit';

/**
 * The home page opening: the promise and the two next steps, beside the
 * service orbit, where every discipline circles one core.
 *
 * `data-reveal` sits on each glass link rather than on their row, because
 * a fading wrapper would blank the glass inside it (base/_motion.scss).
 */
export const Hero = () => {
  return (
    <section className={styles.hero} aria-labelledby="hero-title">
      <HomeBackdrop />

      <div className={styles.copy}>
        <p className={styles.eyebrow} data-reveal="">
          <span className={styles.pulse} aria-hidden="true" />
          {SITE.tagline}
        </p>
        <h1 id="hero-title" className={styles.title} data-reveal="">
          We build the software behind <em>ambitious ideas</em>
        </h1>
        <p className={styles.lede} data-reveal="">
          {SITE.description}
        </p>
        <div className={styles.actions}>
          <GlassLink to={PRIMARY_CTA.to} tone="primary" size="lg" icon="arrowRight" data-reveal="">
            {PRIMARY_CTA.label}
          </GlassLink>
          <GlassLink to="/work" size="lg" data-reveal="">
            See our work
          </GlassLink>
        </div>
      </div>

      <ServiceOrbit />
    </section>
  );
};
